import { render, staticRenderFns } from "./scene3-4mobile.vue?vue&type=template&id=28fd3600&"
import script from "./scene3-4mobile.vue?vue&type=script&lang=js&"
export * from "./scene3-4mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports